if (!customElements.get('share-button')) {
  customElements.define(
    'share-button',
    class ShareButton extends HTMLElement {
      constructor() {
        super();

        this.shareButton = this.querySelector('button.share-button__button');
        this.copyButton = this.querySelector('.share-button__copy');
        this.closeButton = this.querySelector('.share-button__close');
        this.successMessage = this.querySelector('[id^="ShareMessage"]');
        this.urlInput = this.querySelector('.share-button__input');
        this.urlToShare = this.urlInput ? this.urlInput.value : window.location.href;

        // Always try Web Share API
        this.shareButton?.addEventListener('click', this.handleShare.bind(this));
        this.copyButton?.addEventListener('click', this.copyToClipboard.bind(this));
        this.closeButton?.addEventListener('click', () => {
          this.querySelector('details').open = false;
        });
      }

      async handleShare(event) {
        event.preventDefault();
        if (navigator.share) {
          try {
            await navigator.share({
              title: document.title,
              url: this.urlToShare
            });
          } catch (err) {
            this.showFallback(); // User cancelled or not supported
          }
        } else {
          this.showFallback();
        }
      }

      showFallback() {
        const details = this.querySelector('details');
        if (details) details.open = true;
      }

      copyToClipboard() {
        if (!this.urlInput) return;

        navigator.clipboard.writeText(this.urlInput.value).then(() => {
          this.successMessage.classList.remove('hidden');
          this.successMessage.textContent = window.accessibilityStrings?.shareSuccess || "Copied!";
          this.closeButton.classList.remove('hidden');
          this.closeButton.focus();
        });
      }
    }
  );
}
